export enum AppLanguage {
	cs = 'cs',
	sk = 'sk',
	hu = 'hu',
}

export function validateLanguageCode(languageCode: string | null): languageCode is AppLanguage {
	if (!languageCode) {
		return false;
	}

	return (
		languageCode === AppLanguage.cs ||
		languageCode === AppLanguage.sk ||
		languageCode === AppLanguage.hu
	);
}

export function getBcp47LanguageCode(language: AppLanguage): string {
	switch (language) {
		case AppLanguage.cs:
			return 'cs-CZ';
		case AppLanguage.sk:
			return 'sk-SK';
		case AppLanguage.hu:
			return 'hu-HU';
		default:
			throw new Error('Unknown language');
	}
}
